document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.newsletter-popup-close');
  const form = popup.querySelector('form');
  if (!form) return;

  // Popup nur 1x pro Besucher anzeigen (nach 5 Sek.)
  function showPopupOnce() {
    if (!localStorage.getItem('newsletterPopupShown')) {
      setTimeout(() => {
        popup.style.display = 'flex';
        localStorage.setItem('newsletterPopupShown', 'true');
      }, 10000);
    }
  }

  // Popup schließen
  function closePopup() {
    popup.style.display = 'none';
  }
  closeBtn.addEventListener('click', closePopup);

  // Fehlermeldung für Checkbox
  const consentCheckbox = form.querySelector('#newsletter-consent');
  const errorMsg = document.createElement('p');
  errorMsg.style = 'color:red; font-size:13px; display:none; margin-top: -0.8rem; margin-bottom: 1rem;';
  errorMsg.textContent = 'Bitte stimme der Datenschutzerklärung zu.';
  consentCheckbox.parentNode.appendChild(errorMsg);

  // Checkbox-Validierung vor Absenden
  form.addEventListener('submit', (e) => {
    if (!consentCheckbox.checked) {
      e.preventDefault();
      errorMsg.style.display = 'block';
    } else {
      errorMsg.style.display = 'none';
    }
  });

  showPopupOnce();
});
